import React from 'react'

const SectionHeader = (props) => {
    return (
        <div id={props?.id} className='section-header mb-5 text-center'>
            <div className='position-relative'>
                <h2 className='m-0 mb-1'>{props?.title}</h2>
                {/* <ArrowIcon/> */}
            </div>
            {/* detail may contain markup; avoid nested <p> */}
            <div className='body-text'>{props?.detail}</div>
        </div>
    )
}

export default SectionHeader
